import { Modulo } from '../type';

export const getUrl = (modulo: Modulo, path: string) => {
  if (!modulo || !path) {
    throw new Error('Módulo e path são obrigatórios.');
  }

  const { hostname, origin } = window.location;
  const isLocalhost = hostname.includes('local');

  return `${origin}${isLocalhost ? '' : `/${modulo}`}${path}`;
};

export const isValidHttpUrl = (url: string) => {
  if (
    !url.toLocaleLowerCase().startsWith('http://') &&
    !url.toLocaleLowerCase().startsWith('https://')
  ) {
    return false;
  }

  try {
    const newUrl = new URL(url);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (e) {
    return false;
  }
};
